import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledSvg = styled.svg``

const SVG = props => {
  const { svg, children } = props
  const { viewBox, description } = svg

  return (
    <StyledSvg viewBox={viewBox} {...props}>
      {description}
      {children}
    </StyledSvg>
  )
}

SVG.propTypes = {
  children: PropTypes.any,
  svg: PropTypes.shape({
    viewBox: PropTypes.string,
    description: PropTypes.object.isRequired
  }).isRequired
}

export default SVG
